export default __webpack_public_path__ + "static/media/logoSection.6bcaf5b6.png";